module.exports = __webpack_public_path__ + "static/img/complete.000143d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/complete.png
// module id = WN6W
// module chunks = 1